import { Toast } from 'bootstrap';
import { css, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { CUSTOM_EVENTS, TOAST_TYPE } from '../constants/constants.js';
import { TOAST_TYPE_TO_BG_CLASS_MAPPER } from '../constants/mappings.js';
import { BaseElement } from './base.element.js';

export class ToastElement extends BaseElement {
  static get properties() {
    return {
      toastOptions: { type: Object, state: true },
      toastBodyText: { type: String, state: true },
      toastTextBg: { type: String, state: true },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .toast {
          --bs-toast-max-width: 350px;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.handleShowToast = this.handleShowToast.bind(this);
    this.toastOptions = {};
    this.toastTextBg = TOAST_TYPE_TO_BG_CLASS_MAPPER[TOAST_TYPE.DANGER];
    this.toastBodyText = 'An error occured';
  }

  connectedCallback() {
    super.connectedCallback?.();
    window.addEventListener(CUSTOM_EVENTS.SHOW_CA_TOAST, this.handleShowToast);
  }

  disconnectedCallback() {
    window.removeEventListener(CUSTOM_EVENTS.SHOW_CA_TOAST, this.handleShowToast);
    super.disconnectedCallback?.();
  }

  firstUpdated() {
    const toast = this.renderRoot.getElementById('caToast');
    if (toast) {
      this.toast = new Toast(toast);
    }
  }

  handleShowToast(event) {
    this.toastOptions = { ...(event.detail ?? {}) };
    this.toastTextBg =
      TOAST_TYPE_TO_BG_CLASS_MAPPER[this.toastOptions.toastType] || TOAST_TYPE_TO_BG_CLASS_MAPPER[TOAST_TYPE.DANGER];
    this.toastBodyText = this.toastOptions.message || 'An error occured';
    this.toast.show();
    const timer = setTimeout(
      () => {
        this.clearToast();
        clearTimeout(timer);
      },
      this.toastOptions.timeout > 0 ? this.toastOptions.timeout : 5000
    );
  }

  clearToast() {
    this.toast.hide();
  }

  render() {
    const toastTypeClasses = { [this.toastTextBg]: true };
    return html`
      <div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3">
        <div
          id="caToast"
          class="toast align-items-center border-0 fade ${classMap(toastTypeClasses)}"
          role="alert"
          data-bs-autohide="false"
        >
          <div class="d-flex">
            <div class="toast-body">
              <div class="toast-body__text">${this.toastBodyText}</div>
            </div>
            <button @click="${this.clearToast}" type="button" class="btn-close btn-close-white me-2 m-auto"></button>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('app-toast', ToastElement);
